/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeoAddressNumber
 */
export interface HeoAddressNumber {
    /**
     * 
     * @type {string}
     * @memberof HeoAddressNumber
     */
    companyCode: string;
    /**
     * 
     * @type {number}
     * @memberof HeoAddressNumber
     */
    number: number;
}

/**
 * Check if a given object implements the HeoAddressNumber interface.
 */
export function instanceOfHeoAddressNumber(value: object): value is HeoAddressNumber {
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function HeoAddressNumberFromJSON(json: any): HeoAddressNumber {
    return HeoAddressNumberFromJSONTyped(json, false);
}

export function HeoAddressNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeoAddressNumber {
    if (json == null) {
        return json;
    }
    return {
        
        'companyCode': json['companyCode'],
        'number': json['number'],
    };
}

export function HeoAddressNumberToJSON(json: any): HeoAddressNumber {
    return HeoAddressNumberToJSONTyped(json, false);
}

export function HeoAddressNumberToJSONTyped(value?: HeoAddressNumber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyCode': value['companyCode'],
        'number': value['number'],
    };
}

